import VideoService from "../../services/Video";
import { Video } from "../../types";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

import { QUERY_KEY } from "./useListVideos";

export const makeQueryKey = (id?: Video["id"]) => [QUERY_KEY, id];

function useFetchVideo(id?: Video["id"], { enabled = true } = {}) {
  const key = makeQueryKey(id);

  return useAuthorizedQuery(
    key,
    () => {
      if (id) {
        return VideoService.fetchVideo(id);
      }

      throw new Error("video id is required");
    },
    { enabled: !!id && enabled }
  );
}

export default useFetchVideo;
